import { AuthLayout } from '@/modules/auth/ui/components'
import { LoadingSpinner } from '@/shared/ui/components'
import type { ExchangeCodeForSession } from '@/modules/auth/use-cases'
import { useAuthCallbackPage } from './hooks/use-auth-callback-page'

export type AuthCallbackPageProps = {
  onExchangeCodeForSession: ExchangeCodeForSession
}

export function AuthCallbackPage({ onExchangeCodeForSession }: AuthCallbackPageProps) {
  const vm = useAuthCallbackPage({ onExchangeCodeForSession })

  return (
    <AuthLayout title="Signing you in" subtitle="Hang tight while we finish setting up your session.">
      <div
        data-testid="auth-callback-loading"
        className="flex flex-col items-center justify-center gap-3 py-6"
      >
        <LoadingSpinner size="lg" />
        <p className="text-sm text-muted-foreground">{vm.message}</p>
      </div>
    </AuthLayout>
  )
}
